<app-page-template
  (clearQueryString)="onClearQueryString()"
  [showParent]="showParent"
  [class.d-none]="
    isShowUserDocumentation ||
    isShowUserAuthentication ||
    isShowUsersImportFromXlsx ||
    isShowResellerOrganizations ||
    isShowTransferPrivateNumber ||
    isShowUserTransactions ||
    isShowUserPrivateNumbersLists
  "
  [config]="pageConfig"
  (onAdd)="onCreate()"
  (sortObject)="getSortItems($event)"
  (onShowAuditPage)="onShowAuditPage()"
  (onShowHelpPage)="onShowHelpPage()"
  (comparisonObjects)="getComparisonObjects($event)"
  (pageNumber)="changePageNumber($event)"
  (pageSize)="changePageSize($event)"
>
  <div class="card-toolbar" before-btns>
    <!--reseller-->
    <div class="tw-w-[300px]" *ngIf="currentUserInfo.isSuperAdmin">
      <resellers-select-search
        label="common.reseller"
        [control]="form?.get('resellerId')"
        type="currentOrganizationResellers"
        [(value)]="resellerUserId"
        (valueChange)="onChangeReseller($event)"
      >
      </resellers-select-search>
    </div>

    <!--mobile-->
    <div class="tw-w-[300px] tw-mt-1 tw-p-1">
      <form-field
        [isLtr]="true"
        [(value)]="mobile"
        [control]="form?.get('mobile')"
        [label]="'common.mobile' | translate"
      >
      </form-field>
    </div>

    <!-- search btn -->
    <button
      (click)="onSearch()"
      class="btn btn-hover-rise btn-primary button-shadow tw-mx-1 txt-lg"
      type="button"
      mat-ripple
      [matTooltip]="'common.search' | translate"
    >
      <i class="mdi mdi-magnify mdi-20px tw-p-0 tw-text-white"></i>
    </button>
  </div>
  <!--------------------------------------- Audit btns ---------------------------------------->
  <!-- before-btns -->
  <div class="card-toolbar">
    <!-- audit menu btn -->
    <a
      *ngIf="userSession?.isSuperAdmin()"
      [matMenuTriggerFor]="menu"
      class="btn btn-light txt-lg button-shadow tw-mx-1"
      type="button"
      mat-ripple
      [matTooltip]="'pages.audits.title' | translate"
    >
      <i class="mdi mdi-eye mdi-20px tw-p-0 text-info"></i>
    </a>

    <mat-menu #menu="matMenu" xPosition="after">
      <!-- organizations audit -->
      <a
        mat-menu-item
        class="txt-lg button-shadow tw-flex tw-items-center border-bottom"
        mat-ripple
        (click)="onShowAuditPage()"
      >
        <span class="tw-mx-1">{{ "pages.users.title" | translate }}</span>
      </a>

      <!-- user organizations audit -->
      <a
        mat-menu-item
        class="txt-lg button-shadow tw-flex tw-items-center"
        mat-ripple
        (click)="onShowUserOrganizationAuditPage()"
      >
        <span class="tw-mx-1">{{ "pages.users.title" | translate }}</span>
      </a>
    </mat-menu>
  </div>

  <div class="card-toolbar" after-btns>
    <!-- excel btn -->
    <button
      [disabled]="(items$ | async)?.length == 0"
      (click)="onExcelReport()"
      class="btn btn-light txt-lg button-shadow tw-mx-1 btn-hover-rise"
      type="button"
      mat-ripple
      [matTooltip]="'common.downloadExcel' | translate"
    >
      <i class="mdi mdi-download mdi-20px tw-p-0 text-info"></i>
    </button>

    <!--reseller excel btn -->
    <button
      *ngIf="currentUserInfo.isSuperAdmin"
      [disabled]="(items$ | async)?.length == 0"
      (click)="onResellerExcelReport()"
      class="btn btn-light txt-lg button-shadow tw-mx-1 btn-hover-rise"
      type="button"
      mat-ripple
      [matTooltip]="'common.downloadResellerExcel' | translate"
    >
      <i class="mdi mdi-download mdi-20px tw-p-0 text-info"></i>
    </button>

    <a
      [matMenuTriggerFor]="addMenu"
      class="btn txt-lg button-shadow tw-ml-2 tw-flex tw-items-center"
      [themeColor]="'btn'"
      mat-ripple
    >
      <span class="tw-mx-1">{{ "common.new" | translate }}</span>
      <i class="mdi mdi-chevron-left mdi-18px tw-text-white"></i>
    </a>

    <mat-menu #addMenu="matMenu" xPosition="after">
      <!-- addSingle -->
      <a
        mat-menu-item
        class="txt-lg button-shadow tw-font-medium tw-flex tw-items-center border-bottom"
        mat-ripple
        (click)="onCreate()"
      >
        <span class="tw-mx-1 text-navyBlue">
          <i
            class="mdi mdi-plus-circle-outline mdi-24px text-navyBlue tw-ml-1"
          ></i>
          {{ pageVocabs + "addBtns.addSingle" | translate }}
        </span>
      </a>
      <!-- addFromFile -->
      <a
        mat-menu-item
        class="txt-lg button-shadow tw-font-medium tw-flex tw-items-center"
        mat-ripple
        (click)="onShowImportUsersFromXlsx()"
      >
        <span class="tw-mx-1 text-navyBlue">
          <i
            class="mdi mdi-file-upload-outline mdi-24px text-navyBlue tw-ml-1"
          ></i>
          {{ pageVocabs + "addBtns.addFromFile" | translate }}
        </span>
      </a>
    </mat-menu>
  </div>

  <!--------------------------------------- Table Content ---------------------------------------->
  <ng-container table-body *ngIf="(items$ | async) && !pageConfig.loading">
    <ng-container *ngFor="let item of items$ | async; let i = index">
      <tr
        #row
        (click)="onActiveRow(row, i)"
        [class.row-active]="rowIndexSelected == i"
        [ngClass]="currentDateTime > item.expireDate ? 'tr-expired' : ''"
      >
        <!-- index -->
        <td class="tw-text-center !tw-p-4">
          {{ paginationModel?.firstIndex + i }}
        </td>

        <!-- userName -->
        <td>
          <td-value
            class="tw-font-medium"
            copyToClipboard
            [value]="item?.userName"
          ></td-value>
        </td>

        <!-- firstName -->
        <td>
          <td-value
            class="tw-font-medium"
            copyToClipboard
            [value]="item?.firstName"
          ></td-value>
        </td>

        <!-- lastName -->
        <td>
          <td-value
            class="tw-font-medium"
            copyToClipboard
            [value]="item?.lastName"
          ></td-value>
        </td>

        <!-- mobile -->
        <td>
          <app-expand-item
            *ngIf="item?.mobile?.length > 0"
            [isCustom]="true"
            [placement]="'left'"
          >
            <ul class="custom dir-rtl tw-mb-0">
              <li *ngFor="let item of item?.mobile" class="tw-mb-1">
                {{ item?.mobile }}
                <span>
                  <i
                    class="mdi mdi-check-bold text-success mdi-18px"
                    *ngIf="item.isAuthenticated"
                  ></i>
                  <i
                    class="mdi mdi-close-thick text-danger mdi-18px"
                    *ngIf="!item.isAuthenticated"
                  ></i>
                </span>
              </li>
            </ul>
          </app-expand-item>
        </td>

        <!-- nationalCode -->
        <td>
          <td-value copyToClipboard [value]="item?.nationalCode"></td-value>
        </td>

        <!-- organizationName -->
        <td>
          <td-value copyToClipboard [value]="item?.organizationName"></td-value>
        </td>

        <!-- parentOrganization -->
        <td>
          <td-value
            copyToClipboard
            [value]="item?.parentOrganizationName"
          ></td-value>
        </td>

        <!-- DomainName  -->
        <!-- [copyValue]="item?.userDomainLink" -->
        <td>
          <td-value copyToClipboard [value]="item?.domainName"></td-value>
        </td>

        <!-- credit -->
        <td>
          <span
            copyToClipboard
            [class]="fontSize == 'sm' ? 'tw-text-[11px]' : 'tw-text-[12px]'"
            [credit]="item?.credit"
            >{{ item?.credit | numberSeparator | checkValue }}</span
          >
        </td>

        <!-- roles -->
        <td>
          <app-expand-item
            *ngIf="item?.roles?.length > 1"
            [isCustom]="true"
            [placement]="'left'"
          >
            <ul class="custom dir-rtl tw-mb-0">
              <li *ngFor="let item of item?.roles" class="tw-mb-1">
                {{ item }}
              </li>
            </ul>
          </app-expand-item>

          <td-value
            *ngIf="item?.roles?.length < 2"
            copyToClipboard
            type="number"
            [value]="item?.roles[0]"
          >
          </td-value>
        </td>

        <!-- isActiveSend -->
        <td>
          <td-value type="boolean" [value]="item?.isActiveSend"></td-value>
        </td>

        <!-- isLockOut  -->
        <td>
          <td-value type="boolean" [value]="item?.isLockout"></td-value>
        </td>

        <!-- isAuthenticated -->
        <td>
          <td-value type="boolean" [value]="item?.isAuthenticated"></td-value>
        </td>

        <!-- isAuthenticatedMobile -->
        <!-- <td>
          <td-value
            type="boolean"
            [value]="item?.isAuthenticatedMobile"
          ></td-value>
        </td> -->

        <!-- isAdmin -->
        <td>
          <td-value type="boolean" [value]="item?.isAdmin"></td-value>
        </td>

        <!-- expireDate -->
        <td>
          <td-value
            type="dateTimeWithSpace"
            [value]="item?.expireDate"
          ></td-value>
        </td>

        <!-- created -->
        <td>
          <td-value type="dateTimeWithSpace" [value]="item?.created"></td-value>
        </td>

        <!------------------------------- operations -------------------------------->
        <td class="sticky-td">
          <div
            app-menu-btn
            [matMenuTriggerFor]="menu"
            [isShowDotsMenu]="true"
          ></div>

          <mat-menu #menu="matMenu" xPosition="before">
            <!-- login button -->

            <div
              *ngIf="
                !isLoginByIdentity && item.id != userSession.userState()?.userId
              "
              app-menu-btn
              icon="mdi mdi-login-variant mdi-20px"
              color="gray"
              [title]="'common.login'"
              (click)="onUserImpersonate(item?.id)"
            ></div>

            <!-- edit button -->
            <div
              app-menu-btn
              *ngIf="item?.organizationName != null"
              icon="edit"
              (click)="
                isAdmin = item?.isAdmin;
                onUpdate(item?.id, item?.organizationId)
              "
            ></div>

            <!-- organizations button -->
            <div
              app-menu-btn
              icon="mdi mdi-table-network mdi-20px"
              color="blue"
              [title]="'common.organizations'"
              (click)="onShowResellerOrganizations(item.id)"
            ></div>

            <!-- Increase User Credit -->
            <!-- (userSession?.isSuperAdmin() || userSession.userState()?.isAdmin) -->
            <div
              app-menu-btn
              *ngIf="item.organizationName != null"
              icon="mdi mdi-credit-card-outline mdi-20px"
              color="green"
              [title]="'common.creditTransfer'"
              (click)="onShowIncreaseUserCredit(item)"
            ></div>

            <!-- update password -->
            <div
              app-menu-btn
              icon="mdi mdi-lock mdi-20px"
              color="gray"
              [title]="'common.changePassword'"
              (click)="onUpdatePassword(item?.id)"
            ></div>

            <!-- user documentation button -->
            <div
              app-menu-btn
              icon="mdi mdi-folder-account-outline mdi-20px"
              color="navyBlue"
              [title]="'common.documentation'"
              (click)="onShowDocumentations(item?.id)"
            ></div>

            <!-- Transfer private number button -->
            <div
              app-menu-btn
              *ngIf="
                !item.isHavePrivateNumberLimit &&
                item.organizationId == userSession.organizationId()
              "
              icon="mdi mdi-transfer-left mdi-20px"
              color="yellow"
              [title]="'common.transferPrivateNumber'"
              (click)="onTransferPrivateNumber(item.id)"
            ></div>

            <!-- LockOut button -->
            <div
              *ngIf="
                item?.isLockout &&
                (userSession?.isSuperAdmin() ||
                  userSession.isAdminOrganization() ||
                  userSession.organizationId() == 1)
              "
            >
              <div
                app-menu-btn
                icon="mdi mdi-account-lock-open-outline mdi-20px"
                color="green"
                [title]="'common.unblock'"
                (click)="onLockOut(item.userName)"
              ></div>
            </div>

            <!-- transactions button -->
            <div
              app-menu-btn
              icon="mdi mdi-credit-card mdi-20px"
              color="yellow"
              [title]="'common.transactions'"
              (click)="onShowTransactions(item.userName)"
            ></div>

            <!-- show numbers button -->
            <div
              app-menu-btn
              icon="mdi mdi-numeric mdi-20px"
              color="green"
              [title]="'common.privateNumbers'"
              (click)="onShowPrivateNumbers(item.id)"
            ></div>

            <!-- delete button -->
            <div
              app-menu-btn
              icon="delete"
              (click)="onDelete(item.id, item.userName)"
            ></div>
          </mat-menu>
        </td>
      </tr>
    </ng-container>
  </ng-container>
</app-page-template>

<!-- add or update form -->
<ng-container *ngIf="pageConfig?.isVisibleForm">
  <app-user-form
    [formPageConfig]="formPageConfig"
    [isAdmin]="isAdmin"
    [selectedOrganizationId]="selectedOrganizationId"
    (closeFormPage)="getFormResponse($event)"
  >
  </app-user-form>
</ng-container>

<!-- Audit -->
<ng-container *ngIf="pageConfig?.isVisibleAuditPage">
  <app-audit
    [service]="currentService"
    [methodName]="auditApiMethodName"
    (hidePage)="onHideAuditPage()"
  >
  </app-audit>
</ng-container>

<!--user documentation -->
<ng-container *ngIf="isShowUserDocumentation">
  <app-user-documentation-form
    [documentationTypes]="DocumentationTypeEnumValues"
    [userId]="selectedUserId"
    (closeFormPage)="getFormResponse($event); onHideDocumentations()"
  >
  </app-user-documentation-form>
</ng-container>

<!-- reseller organizations -->
<ng-container *ngIf="isShowResellerOrganizations">
  <app-reseller-organizations
    [modelWithPagination$]="resellersOrganizationsWithPagination$"
    [userId]="selectedUserId"
    (onBack)="onHideResellerOrganizations()"
  >
  </app-reseller-organizations>
</ng-container>

<!-- user transactions  -->
<ng-container *ngIf="isShowUserTransactions">
  <app-user-transactions
    [modelWithPagination$]="userTransactionsWithPagination$"
    [userName]="selectedUserName"
    (onBack)="onHideTransactions()"
    [parentPageName]="pageName"
  >
  </app-user-transactions>
</ng-container>

<!--------------------------------------- help --------------------------------------->
<ng-container *ngIf="pageConfig?.isVisibleHelpPage">
  <app-help-page
    [menuTitle]="'UsersList'"
    (hidePage)="onHideHelpPage()"
    [title]="pageConfig.title"
  >
  </app-help-page>
</ng-container>

<!-- add numbers from xlsx file -->
<app-users-import-from-xlsx
  *ngIf="isShowUsersImportFromXlsx"
  (closeFormPage)="getImportNumbersFromXlsxResponse()"
>
</app-users-import-from-xlsx>

<!-- form -->
<ng-container *ngIf="isShowTransferPrivateNumber">
  <app-private-number-send-limit-form
    [formPageConfig]="transferPrivateNumberFormPageConfig"
    [usersId]="selectedUserId"
    (closeFormPage)="getTransferPrivateNumberFormResponse($event)"
  >
  </app-private-number-send-limit-form>
</ng-container>

<ng-container *ngIf="isShowUserPrivateNumbersLists">
  <app-user-private-numbers
    [model]="userPrivateNumbersList"
    [userId]="userId"
    (closePage)="onHidePrivateNumbers()"
  ></app-user-private-numbers>
</ng-container>

<!--user organization Audit -->
<!-- <ng-container *ngIf="userOrganizationAuditPage">
  <app-audit [service]="UserOrganizationsService" methodName="groupPriceDetailsGetGroupPriceDetailsAudit"
    (hidePage)="onHideUserOrganizationAuditPage()">
  </app-audit>
</ng-container> -->
